<template>
  <div style="display: inline-flex; height: 100%">


    <mu-raised-button icon="image" @click.native="onBtnClick()" label="Add pictures"></mu-raised-button>
    <input style="display:none" v-bind:id="id" accept="image/png,image/jpg" type="file" multiple @change="fileInputChanged">
  </div>
</template>
<script>
  import $ from 'jquery'
  import axios from 'axios'
  import config from '../../../config'

  export default {
    name: "multiple-image-uploader",
    props: {
      existingImages: {
        default: () => []
      }
    },
    data() {
      return {
        id: null,
        images: [],
        imageUrls: []
      }
    },
    mounted() {
      this.id = 'multi_uploader_' + this._uid;
    },
    methods: {
      onBtnClick() {
        let self = this;
        $('#' + self.id).click();
      },
      fileInputChanged(e) {
        let self = this;
        self.images = [];
        self.imageUrls = [];

        let images = [];
        let imageUrls = [];

        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) {
          return;
        }
        if (files.length > 0) {
          let fl = files.length;
          for (let i = 0; i < fl; i++) {
            let reader = new FileReader();
            let file = files[i];
            reader.readAsDataURL(file);
            reader.onload = function (e) {
              let dataURI = e.target.result;
              if (dataURI) {
                images.push(dataURI);
                self.images.push(dataURI);

                self.$nextTick(function () {
                  //check this is the last file, upload images to cloud and return response to v-model

                  if (i === files.length - 1) {
                      self.$emit('uploading', true);
                      axios.post(config.apiUrl + 'uploader/files', {
                        files: images,
                        dimensions: {
                          width: 700,
                          height: 400
                        }
                      }).then(response => {
                        imageUrls = self.existingImages
                        for (let imi = 0; imi < response.data.length; imi++) {
                          imageUrls.push(response.data[imi].secure_url);
                          self.imageUrls.push(response.data[imi].secure_url);
                          self.$emit('input', imageUrls);
                          self.$emit('uploading',false)
                        }
                      })
                    }

                })
              }
            }
          }
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MultipleImageUploader.vue?2a71ea7e